import { CreateNamespaceDto } from '@routellers/types/dist/translation/create-namespace.dto';
import { NamespaceRO } from '@routellers/types/dist/translation/namespace.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = { data: CreateNamespaceDto };

type ResponseData = NamespaceRO;

export const createNamespace: ApiMethodDeclaration<ParamsData, ResponseData> = ({ data }) => ({
    url: '/translations/namespaces',
    method: 'POST',
    data,
});
